import { getErrorObject } from '@/utils/error';
import { infoReport } from '@/utils/report';

import { Client } from '@/types/app';
import type { Args, Events, FacebookQuery } from './types';

export * from './types';

class Pixel {
  private static instance: Pixel;
  private fbq: FacebookQuery | null = null;
  private client: Client | null = null;

  private constructor() {}

  isEnableClient() {
    return this.client && !this.client.isWebView;
  }

  static getInstance(): Pixel {
    if (!Pixel.instance) {
      Pixel.instance = new Pixel();
    }
    return Pixel.instance;
  }

  async setup(client: Client) {
    this.client = client;
    if (this.fbq || !window.fbq) {
      return;
    }
    this.fbq = window.fbq;
  }

  async pageView() {
    if (!this.isEnableClient()) {
      return;
    }
    try {
      if (!this.fbq) {
        infoReport('Pixel:pageView > fbq is not initialized', {});
        return;
      }
      this.fbq('track', 'PageView');
    } catch (error) {
      infoReport('Pixel:pageView > error', { error }, getErrorObject(error));
    }
  }

  async trackCustom(event: string, data?: Record<string, unknown>) {
    if (!this.isEnableClient()) {
      return;
    }
    try {
      if (!this.fbq) {
        infoReport('Pixel:trackCustom > fbq is not initialized', {});
        return;
      }
      this.fbq('trackCustom', event, data);
    } catch (error) {
      infoReport('Pixel:trackCustom > error', { error }, getErrorObject(error));
    }
  }

  async track<E extends keyof Events>(event: E, ...args: Args<Events, E>) {
    if (!this.isEnableClient()) {
      return;
    }
    try {
      if (!this.fbq) {
        infoReport('Pixel:track > fbq is not initialized', {});
        return;
      }
      this.fbq('track', event, ...args);
    } catch (error) {
      infoReport('Pixel:track > error', { error }, getErrorObject(error));
    }
  }

  static async setup(client: Client) {
    return Pixel.getInstance().setup(client);
  }

  static async pageView() {
    return Pixel.getInstance().pageView();
  }

  static async trackCustom(event: string, data?: Record<string, unknown>) {
    return Pixel.getInstance().trackCustom(event, data);
  }

  static async track<E extends keyof Events>(event: E, ...args: Args<Events, E>) {
    return Pixel.getInstance().track(event, ...args);
  }
}

export default Pixel;
